if (customElements.get("marquee-support")) {} else {
    const MAX_CLONES = 20;
    const FINE_POINTER = "(hover: hover) and (pointer: fine)";
    customElements.define("marquee-support", class MarqueeSupport extends HTMLElement {
        constructor() {
            super();
            this.container = this.querySelector(".marquee");
            this.content = this.container?.querySelector(".marquee__content");
            this.resizeObserver = null;
            this.animations = [];
            this.paused = false;
            this.contentWidth = 0;
            this.gap = 0;
            this._speed = 10;
            this.allContent = [];
            this._active = false;
            this._hoverPaused = false;
            this._focusPaused = false;
            this._hoverPlaying = false;
            this._hoverMedia = null;
            this._onHoverMediaChange = () => {
                this._hoverPaused = false;
                this._hoverPlaying = false;
                this.applyPausedState();
            };
            this._onMouseEnter = () => {
                if (!this._hoverMedia || !this._hoverMedia.matches) return;
                if (this.container.classList.contains("marquee--hover-play")) this._hoverPlaying = true; else this._hoverPaused = true;
                this.applyPausedState();
            };
            this._onMouseLeave = () => {
                this._hoverPaused = false;
                this._hoverPlaying = false;
                this.applyPausedState();
            };
            this._onFocusIn = () => {
                this._focusPaused = true;
                this.applyPausedState();
            };
            this._onFocusOut = () => {
                this._focusPaused = false;
                this.applyPausedState();
            };
        }
        connectedCallback() {
            if (!this.container || !this.content) return;
            if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
            if (typeof this.content.animate !== "function") return;
            this.bindInteraction();
            this.observeResize();
            this.applyPausedState();
            this.rebuild();
            if (document.fonts) document.fonts.ready.then(() => {
                if (this.isConnected) this.rebuild();
            });
        }
        cloneUntilFull() {
            const original = this.content;
            const containerWidth = this.container.offsetWidth;
            const contentWidth = original.scrollWidth;
            this.container.querySelectorAll('.marquee__content[aria-hidden="true"]').forEach(el => el.remove());
            if (containerWidth <= 0 || contentWidth <= 0) {
                this.allContent = [ ...this.container.querySelectorAll(".marquee__content") ];
                return;
            }
            let totalWidth = contentWidth;
            let count = 0;
            while ((totalWidth < containerWidth * 2 || count === 0) && count < MAX_CLONES) {
                const clone = original.cloneNode(true);
                clone.setAttribute("aria-hidden", "true");
                this.container.appendChild(clone);
                totalWidth += contentWidth;
                count++;
            }
            this.allContent = [ ...this.container.querySelectorAll(".marquee__content") ];
        }
        measure() {
            this.contentWidth = this.content.scrollWidth;
            const style = getComputedStyle(this.container);
            this.gap = parseFloat(style.columnGap) || 0;
            this._speed = parseFloat(style.getPropertyValue("--speed")) || 10;
            const clone = this.container.querySelector('.marquee__content[aria-hidden="true"]');
            this._active = clone ? getComputedStyle(clone).display !== "none" : false;
        }
        rebuild() {
            this.cancelAnimations();
            this.cloneUntilFull();
            this.measure();
            this.startAnimations();
        }
        startAnimations() {
            this.animations = [];
            if (!this._active || this.contentWidth <= 0) return;
            const keyframes = [ {
                transform: "translate3d(0, 0, 0)"
            }, {
                transform: `translate3d(-${this.contentWidth + this.gap}px, 0, 0)`
            } ];
            const options = {
                duration: this._speed * 1e3,
                iterations: Infinity,
                easing: "linear"
            };
            for (const el of this.allContent) {
                const animation = el.animate(keyframes, options);
                if (this.paused) animation.pause();
                this.animations.push(animation);
            }
        }
        cancelAnimations() {
            for (const animation of this.animations) animation.cancel();
            this.animations = [];
        }
        setPaused(paused) {
            this.paused = paused;
            for (const animation of this.animations) if (paused) animation.pause(); else animation.play();
        }
        applyPausedState() {
            if (this.container.classList.contains("marquee--hover-play")) this.setPaused(!this._hoverPlaying); else if (this.container.classList.contains("marquee--focus-pause")) this.setPaused(this._hoverPaused || this._focusPaused); else this.setPaused(false);
        }
        bindInteraction() {
            this._hoverMedia = window.matchMedia(FINE_POINTER);
            this._hoverMedia.addEventListener("change", this._onHoverMediaChange);
            if (this.container.classList.contains("marquee--focus-pause")) {
                this.container.addEventListener("mouseenter", this._onMouseEnter);
                this.container.addEventListener("mouseleave", this._onMouseLeave);
                this.container.addEventListener("focusin", this._onFocusIn);
                this.container.addEventListener("focusout", this._onFocusOut);
            }
            if (this.container.classList.contains("marquee--hover-play")) {
                const hoverTarget = this.closest(".group") || this.container;
                hoverTarget.addEventListener("mouseenter", this._onMouseEnter);
                hoverTarget.addEventListener("mouseleave", this._onMouseLeave);
            }
        }
        observeResize() {
            let resizeTimeout;
            this.resizeObserver = new ResizeObserver(() => {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(() => this.rebuild(), 100);
            });
            this.resizeObserver.observe(this.container);
            this.resizeObserver.observe(this.content);
        }
        disconnectedCallback() {
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this._hoverMedia) this._hoverMedia.removeEventListener("change", this._onHoverMediaChange);
            this.cancelAnimations();
        }
    });
}